@if (demoLoginRequired) {
  <main class="demo-auth-background" aria-hidden="true">
    <div class="demo-auth-brand">
      <img src="assets/images/logo_v2.png" alt="" />
      <span>Spotlight</span>
    </div>
    <div class="demo-auth-copy">
      <span>Linkworld Demo Workspace</span>
      <h1>聚光投放管理演示环境</h1>
      <p>完成访问验证后，即可查看演示账户与完整功能。</p>
    </div>
    <div class="demo-auth-shape demo-auth-shape-primary"></div>
    <div class="demo-auth-shape demo-auth-shape-secondary"></div>
  </main>
  <app-demo-login-modal
    [visible]="true"
    (loginSuccess)="reloadPage()"
  ></app-demo-login-modal>
} @else {
  <div class="main-wrap">
    <!-- 演示环境下常驻。刻意不可关闭：访客共用同一份数据，界面上没有持续提示的话，
         他会把别人的演示改动当成自己的投放结果。 -->
    @if (isDemo) {
      <app-demo-banner></app-demo-banner>
      <!-- 演示时页面是智能体在点，人只能看结果 —— 用箭头把「点的是哪儿」画出来 -->
      <app-demo-cursor></app-demo-cursor>
      <!-- 导出成功后把那张表弹出来给客户看（文件落在下载目录里，他看不见） -->
      <app-demo-export-preview></app-demo-export-preview>
    }
    @if (show) {
      <nz-layout>
        <nz-header class="app-header">
          <app-main-header></app-main-header>
        </nz-header>
        <nz-content>
          <div class="inner-content">
            <router-outlet></router-outlet>
          </div>
        </nz-content>
        <nz-footer class="main-footer">
          <app-main-footer></app-main-footer>
        </nz-footer>
      </nz-layout>
    }
    @if (!show) {
      <nz-layout>
        <nz-spin nzTip="正在从小红书服务器同步数据，请稍候...">
          <div style="height: 100vh">
            <nz-content> </nz-content>
            <nz-footer> </nz-footer>
          </div>
        </nz-spin>
      </nz-layout>
    }
  </div>
}
